/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScuolaAssegnataItem } from './scuola-assegnata-item';


export interface ServizioOperatoreScuoleDTO { 
    assegnate?: Array<ScuolaAssegnataItem>;
    totale_assegnate?: number;
    totale_assegnabili?: number;
}

